const SKELETON_WORKFLOW = `
<div style="animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-bottom:1.5rem;">
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:8rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:10rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
  </div>
  <div style="height:0.875rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.75rem;"></div>
  <div style="border:1px solid #e5e7eb;border-radius:0.5rem;overflow:hidden;">
    <div style="background:#f9fafb;padding:0.5rem 0.75rem;display:flex;gap:2rem;">
      <div style="height:0.625rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.625rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.625rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.625rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
    </div>
    <div style="padding:0.625rem 0.75rem;border-top:1px solid #e5e7eb;display:flex;gap:2rem;">
      <div style="height:0.75rem;width:8rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div>
    </div>
    <div style="padding:0.625rem 0.75rem;border-top:1px solid #e5e7eb;display:flex;gap:2rem;">
      <div style="height:0.75rem;width:7rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div>
    </div>
    <div style="padding:0.625rem 0.75rem;border-top:1px solid #e5e7eb;display:flex;gap:2rem;">
      <div style="height:0.75rem;width:9rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;"></div>
      <div style="height:0.75rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div>
    </div>
  </div>
</div>`;

const SKELETON_TASK = `
<div style="animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-bottom:1.5rem;">
    <div><div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:8rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:12rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:10rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:10rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
  </div>
  <div style="height:0.75rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div>
  <div style="background:#f9fafb;border-radius:0.5rem;padding:0.75rem;margin-bottom:1rem;">
    <div style="height:0.625rem;width:100%;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div>
    <div style="height:0.625rem;width:80%;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div>
    <div style="height:0.625rem;width:60%;background:#e5e7eb;border-radius:0.25rem;"></div>
  </div>
</div>`;

export default function workflowModal() {
  return {
    modalOpen: false,
    currentWorkflowId: null,
    currentTaskId: null,
    modalTitle: "",
    basePath: "/admin/workflows",
    _autoRefreshTimer: null,

    init() {
      // Check URL on page load
      const wfMatch = window.location.pathname.match(
        /\/workflows\/([0-9a-f-]+)/,
      );
      if (wfMatch) {
        const taskMatch = window.location.pathname.match(
          /\/tasks\/([0-9a-f-]+)/,
        );
        if (taskMatch) {
          this.currentWorkflowId = wfMatch[1];
          this.loadTask(wfMatch[1], taskMatch[1]);
        } else {
          this.loadWorkflow(wfMatch[1]);
        }
      }

      // Handle browser back/forward
      window.addEventListener("popstate", () => {
        const wf = window.location.pathname.match(
          /\/workflows\/([0-9a-f-]+)/,
        );
        if (wf) {
          const task = window.location.pathname.match(
            /\/tasks\/([0-9a-f-]+)/,
          );
          if (task) {
            this.currentWorkflowId = wf[1];
            this.currentTaskId = task[1];
            this.modalTitle = "Task detail";
            this._fetchIntoModal(
              this.basePath + "/" + wf[1] + "/tasks/" + task[1],
              SKELETON_TASK,
            );
          } else {
            this.currentWorkflowId = wf[1];
            this.currentTaskId = null;
            this.modalTitle = "Workflow";
            this._fetchIntoModal(
              this.basePath + "/" + wf[1],
              SKELETON_WORKFLOW,
            );
          }
        } else {
          this.modalOpen = false;
          this.currentWorkflowId = null;
          this.currentTaskId = null;
        }
      });

      // Listen for task clicks from within workflow modal content
      this.$el.addEventListener("open-task", (e) => {
        const taskId = e.detail.taskId;
        if (this.currentWorkflowId && taskId) {
          this.loadTask(this.currentWorkflowId, taskId);
        }
      });
    },

    openWorkflow(workflowId) {
      history.pushState(null, "", this.basePath + "/" + workflowId);
      this.loadWorkflow(workflowId);
    },

    loadWorkflow(workflowId) {
      this.currentWorkflowId = workflowId;
      this.currentTaskId = null;
      this.modalTitle = "Workflow";
      this.modalOpen = true;
      this._fetchIntoModal(
        this.basePath + "/" + workflowId,
        SKELETON_WORKFLOW,
      );
    },

    loadTask(workflowId, taskId) {
      this._stopAutoRefresh();
      this.currentWorkflowId = workflowId;
      this.currentTaskId = taskId;
      this.modalTitle = "Task detail";
      this.modalOpen = true;
      history.pushState(
        null,
        "",
        this.basePath + "/" + workflowId + "/tasks/" + taskId,
      );
      this._fetchIntoModal(
        this.basePath + "/" + workflowId + "/tasks/" + taskId,
        SKELETON_TASK,
      );
    },

    backToWorkflow() {
      this.currentTaskId = null;
      this.modalTitle = "Workflow";
      history.pushState(
        null,
        "",
        this.basePath + "/" + this.currentWorkflowId,
      );
      this._fetchIntoModal(
        this.basePath + "/" + this.currentWorkflowId,
        SKELETON_WORKFLOW,
      );
    },

    refreshModal() {
      if (this.currentTaskId) {
        this._fetchIntoModal(
          this.basePath +
            "/" +
            this.currentWorkflowId +
            "/tasks/" +
            this.currentTaskId,
          SKELETON_TASK,
        );
      } else if (this.currentWorkflowId) {
        this._fetchIntoModal(
          this.basePath + "/" + this.currentWorkflowId,
          SKELETON_WORKFLOW,
        );
      }
    },

    closeModal() {
      this._stopAutoRefresh();
      this.modalOpen = false;
      this.currentWorkflowId = null;
      this.currentTaskId = null;
      history.pushState(null, "", this.basePath);
    },

    _stopAutoRefresh() {
      if (this._autoRefreshTimer) {
        clearTimeout(this._autoRefreshTimer);
        this._autoRefreshTimer = null;
      }
    },

    _scheduleAutoRefreshIfNeeded() {
      this._stopAutoRefresh();
      // Only auto-refresh workflow detail (not task detail)
      if (this.currentTaskId) return;
      if (!this.modalOpen) return;

      const statusEl = document.querySelector(
        "#modal-body [data-workflow-status]",
      );
      if (!statusEl) return;
      const status = statusEl.dataset.workflowStatus;
      if (status !== "scheduled" && status !== "in_progress") return;

      this._autoRefreshTimer = setTimeout(() => {
        if (!this.modalOpen || this.currentTaskId) return;
        const url = this.basePath + "/" + this.currentWorkflowId;
        // Silent re-fetch (no skeleton), afterSettle re-schedules
        const body = document.getElementById("modal-body");
        const onSettle = () => {
          body.removeEventListener("htmx:afterSettle", onSettle);
          this._scheduleAutoRefreshIfNeeded();
        };
        body.addEventListener("htmx:afterSettle", onSettle);
        window.htmx.ajax("GET", url, "#modal-body");
      }, 5000);
    },

    _fetchIntoModal(url, skeleton) {
      this._stopAutoRefresh();
      const body = document.getElementById("modal-body");
      if (skeleton) body.innerHTML = skeleton;
      // Listen for htmx settling to schedule auto-refresh
      const onSettle = () => {
        body.removeEventListener("htmx:afterSettle", onSettle);
        this._scheduleAutoRefreshIfNeeded();
      };
      body.addEventListener("htmx:afterSettle", onSettle);
      window.htmx.ajax("GET", url, "#modal-body");
    },
  };
}
